import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';

/* Your code here */

$(document).ready(function($) {

//	$(this).foundation();

	$('.js-lost-panel a.button, a[href="#lost_form_panel"]').on('input', function() {
		if(event.keycode == 13)
		{
			var $this = $(this);
			var $that = $('a.button.found-form');
			var $lost_form_panel = $('.lost-form-panel');
			var $found_form_panel = $('.found-form-panel');
			var $arrow_blue = $this.parent().parent().find('.arrow-blue');
			var $arrow_white = $('.found-panel .arrow-white');
			
			if( ! $lost_form_panel.hasClass('ACTIVE') ) {
				$this.addClass('ACTIVE');
				$that.removeClass('ACTIVE');
				$lost_form_panel.addClass('ACTIVE');
				$arrow_blue.addClass('ACTIVE');
				$arrow_white.removeClass('ACTIVE');
				$found_form_panel.removeClass('ACTIVE');
			}
		}
	})
	
	$('.js-lost-panel a.button, a[href="#lost_form_panel"]').on('click', function() {
		
		console.log('lost-panel clicked');
		
		var $this = $(this);
		var $that = $('a.button.found-form');
		var $lost_form_panel = $('.lost-form-panel');
		var $found_form_panel = $('.found-form-panel');
		var $arrow_blue = $this.parent().parent().find('.arrow-blue');
		var $arrow_white = $('.found-panel .arrow-white');
		
		if( ! $lost_form_panel.hasClass('ACTIVE') ) {
			$this.addClass('ACTIVE');
			$that.removeClass('ACTIVE');
			$lost_form_panel.addClass('ACTIVE');
			$arrow_blue.addClass('ACTIVE');
			$arrow_white.removeClass('ACTIVE');
			$found_form_panel.removeClass('ACTIVE');
		}
		
	});
	
	$('.js-found-panel a.button, a[href="#found_form_panel"]').on('click', function() {
		
		var $this = $(this);
		var $that = $('a.button.lost-form');
		var $found_form_panel = $('.found-form-panel');
		var $lost_form_panel = $('.lost-form-panel');
		var $arrow_white = $this.parent().parent().find('.arrow-white');
		var $arrow_blue = $('.lost-panel .arrow-blue');
		
		if( ! $found_form_panel.hasClass('ACTIVE') ) {
			$this.addClass('ACTIVE');
			$that.removeClass('ACTIVE');
			$found_form_panel.addClass('ACTIVE');
			$arrow_white.addClass('ACTIVE');
			$arrow_blue.removeClass('ACTIVE');
			$lost_form_panel.removeClass('ACTIVE');
		}
		
	});
	
	$('.js-burger a, nav a').on('click', function() {
		
		$('nav').toggleClass('show');
		$('.side-menu-holder').toggleClass('ACTIVE');

		if($('.side-menu-holder').hasClass('ACTIVE'))
		{
			$('nav a').attr('tabindex', '0');
		}
		else {
			$('nav a').attr('tabindex', '-1');
		}		
	});

	$('.lost-map label, .found-map label').on('click', function() {
		
		$('.help').toggleClass('ACTIVE');
		
		var $context = $(this).parent();
		var $content = "Hello, campers!";
		
		if( $context.hasClass('lost-map') ) {
			$content = "<p>Drag the marker to the relevant location. <em>Use the +/- buttons to zoom in/out.</em></p><p>Or enter the location in the &lsquo;Address&rsquo; field below.</p>";
		}
		if( $context.hasClass('found-map') ) {
			$content = "<p>Drag the marker to the location where you found the drone. <em>Use the +/- buttons to zoom in/out.</em></p><p>Or enter the location in the &lsquo;Address&rsquo; field below.</p>";
		}
		
		$('.help__content').html( '<p>' + $content + '</p>' );
		
	});
	
	$('.js-close-help').on('click', function() {
		
		$('.help').removeClass('ACTIVE');
		
	});
	
	
//	$(document).on('gform_confirmation_loaded', function(e, form_id) {
	$(document).bind('gform_confirmation_loaded', function (e, form_id) {
		
	//	alert('submitted - '+form_id);
		$('.submitted').addClass('ACTIVE');
		$('.js-close-submitted').html('<i class="fas fa-times-circle"></i>');
		var $message = '<h3>Thank you for using this site</h3><p>We could not find the form you completed.</p>';
		if( form_id === 3 || form_id === 5 || form_id === 7 ) {
			$message = '<h3>Thank you for using this site</h3><p>We will let you know by email if your drone is reported as found.</p>';
		} else if( form_id === 4 ) {
			$message = '<h3>Thank you for using this site</h3><p>We will let you know by email if this drone is reported as lost.</p>';
		}
		$('.submitted__content').html( $message );
		$('.lost-form-panel').removeClass('ACTIVE');
		$('.found-form-panel').removeClass('ACTIVE');
		
	});
	
	$('.js-close-submitted').on('click', function() {
		
		console.log('close clicked');
		$('.submitted').removeClass('ACTIVE');
		
		// Then  redirect / refresh this page
		window.location.replace('/');
		
	});
	
	
	/*	Scroll slide-up dronesafe logo and add drop-shadow
		--------------------------------------------------------------------- */
	$(window).scroll( function() {
		
		var $scroll_top = $(window).scrollTop();
		
		if( $scroll_top >= 40 ) {
			
			$('.dronesafe img').slideUp(600);
			
			$('.app-head').addClass('page-scrolled');
			
			
		} else {
			
			$('.dronesafe img').slideDown(600);
			
			$('.app-head').removeClass('page-scrolled');
			
		}
		
	});
	
	
	/*	WWAC tweaks
		--------------------------------------------------------------------- */
	$('.gfgeo-locator-button-wrapper > img:not([alt])').attr('alt', 'Geocode');
	$(".cli-modal-close").prop('value', 'Close');
	var $closebtn_html = $('button.cli-modal-close').html();
	$('button.cli-modal-close').html( $closebtn_html + '<span>Close</span>' );
	$('img:not([alt])').attr('alt', '');
	$('#gmimap0').attr('alt', 'Please choose a location');
	$('nav a').attr('tabindex', '-1');
	
	
	/*	SMOOTH SCROLL
		--------------------------------------------------------------------- */
    $(this).on('click', 'a[href*="#"]:not([href="#"])', function(e) {
	    
	    if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            
            var hash = this.hash;
            var target = $(this.hash);
            
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            
            if( hash === '#home' || hash === '#top' ) {
	            
	            $('html, body').animate({
                    
                    scrollTop: 0
                    
                }, 600);
			
				if( $('.side-menu-holder').hasClass('ACTIVE') ) $('.js-burger').click();
                
	            return;
	            
            }
            
			if (target.length) {
					
				$('html, body').animate({
					
				//	scrollTop: target.offset().top - ( $('.app-head').outerHeight() + ( $('.app-head').outerHeight() ) )
					scrollTop: target.offset().top - ( $('.app-head').outerHeight() )
				
				}, 600);
				
				e.preventDefault();
			
				if( $('.side-menu-holder').hasClass('ACTIVE') ) $('.js-burger').click();
				
				return;
			
			}
            
        }
        
    });
  
});


